import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";

export type IPlanEnrollmentListQueryFilter = {
  planType?: planEnrollmentApiSpec.PlanEnrollment["planType"];
  status?: planEnrollmentApiSpec.PlanEnrollment["status"];
  endDate?: { "<"?: Date; ">"?: Date };
};

export enum WorkClassification {
  Driving = "Driving",
  AutoDetailing = "AutoDetailing",
  ClaimsInspector = "ClaimsInspector",
  Clerical = "Clerical"
}
